// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"175":"232b1663e2089b773fc5","363":"6b898ccf8966fa6e6def"}[chunkId] + ".css";
};